import React from 'react'
import MasterLayout from "../masterLayout/MasterLayout";
import Help from '../components/Help';
export default function TicketPage() {
  return (
    <div>
    <MasterLayout>
    <Help/>
    </MasterLayout>
  </div>
  )
}
